// ============================================================================
// activeCargo — cargo ATIVO de um colaborador multi-cargo.
// ----------------------------------------------------------------------------
// Um colaborador pode ter vários cargos (employeeRoles). O cargo ATIVO define a
// VISÃO (abas/menu/dashboards) — trocado pelo seletor no header (igual ao de
// perfil). Guardado em localStorage por uid. A fila de arquivos NÃO é filtrada
// pelo cargo ativo (o colaborador sempre vê tudo atribuído a ele).
// ============================================================================
import { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";

const STORAGE_KEY = (uid) => `activeCargo_${uid || "anon"}`;
const EVENT = "activeCargoChange";

// Lista de cargos do colaborador (employeeRoles, com fallback p/ employeeRole).
export const getEmployeeCargos = (user) => {
  if (Array.isArray(user?.employeeRoles) && user.employeeRoles.length) return user.employeeRoles;
  return user?.employeeRole ? [user.employeeRole] : [];
};

export const useActiveCargo = () => {
  const { user } = useAuth();
  const uid = user?.uid;
  const cargos = getEmployeeCargos(user);
  const cargosKey = cargos.join("|");

  const read = () => {
    const saved = uid ? localStorage.getItem(STORAGE_KEY(uid)) : null;
    if (saved && cargos.includes(saved)) return saved;
    return cargos[0] || null;
  };

  const [activeCargo, setActive] = useState(read);

  useEffect(() => {
    setActive(read());
    const onEvt = () => setActive(read());
    window.addEventListener(EVENT, onEvt);
    return () => window.removeEventListener(EVENT, onEvt);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uid, cargosKey]);

  const setActiveCargo = (c) => {
    if (!uid || !cargos.includes(c)) return;
    localStorage.setItem(STORAGE_KEY(uid), c);
    window.dispatchEvent(new CustomEvent(EVENT));
  };

  return { activeCargo, setActiveCargo, cargos };
};
